import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useRevision } from '../../../../hooks/api';
import { SidebarLayout } from '../../../layouts';
import type { ReportGenerationParams } from '../shared/types';

import ActionButtons from './ActionButtons';
import useReportContainer from './context/useReportContainer';
import Preview from './Preview';
import ReportFilters from './ReportFilters';
import Sidebar from './Sidebar';

import styles from './ReportGenerationV2.module.less';

type Props = {
  params: ReportGenerationParams;
};

const ReportGenerationV2: VoidFunctionComponent<Props> = (props: Props) => {
  const {
    setFormat,
  } = useReportContainer();
  const [isDirty, setIsDirty] = useState(false);
  const resetFormat = () => {
    setIsDirty(false);
    setFormat(null);
  };
  const isVulnerability = props.params.report_type === 'vulnerability';

  const isProjectReport = !!props.params.project_id && !!props.params.revision_id;
  const isLicensingReport = props.params.report_type === 'licensing';
  const projectRevisionLocator = `${props.params.project_id}$${props.params.revision_id}`;

  // Fetch the current revision to determine if project reports should be downloaded or emailed.
  const revisionResponse = useRevision(projectRevisionLocator, isProjectReport && isLicensingReport);

  return (
    <div className={styles.reportGenerationV2Container}>
      <SidebarLayout>
        <SidebarLayout.Main>
          <div className={styles.reportGenerationV2}>
            <Sidebar params={props.params} resetFormat={resetFormat} />
            <Preview params={props.params} />
          </div>
        </SidebarLayout.Main>
        {!isVulnerability && (
          <SidebarLayout.Sidebar>
            <div className={styles.filterSidebar}>
              <ActionButtons
                isDisabled={isDirty}
                reportType={props.params.report_type}
                revision={revisionResponse.data}
              />
              <ReportFilters
                isApplyButtonDisabled={!isDirty}
                reportType={props.params.report_type}
                setIsDirty={setIsDirty}
              />
            </div>
          </SidebarLayout.Sidebar>
        )}
      </SidebarLayout>
    </div>
  );
};

export default ReportGenerationV2;
